import React from 'react';
import videoUtils from '../utils/VideoUtils';
import { ControlPoint } from '../videoEditor/ControlPoint';
import { ShadowArea } from '../videoEditor/ShadowArea';
import { VideoMarker } from '../videoEditor/VideoMarker';

export const VideoTrack = React.createClass({
    render() {
        const menuStyle = {
            position: 'absolute',
            backgroundColor: '#BEBEBE',
            width: this.props.width,
            height: this.props.height,
            top: this.props.top,
            left: this.props.left,
            cursor: 'default',
            userSelect: 'none',
            userDrag: 'none',
            WebkitUserSelect: 'none'
        };

        return (
            <div style={menuStyle}>
                <VideoMarker trackHeight={this.props.height} trackWidth={this.props.width} globalLeft={this.props.globalLeft} refreshVideoEditor={this.props.refreshVideoEditor}/>
                <ShadowArea trackHeight={this.props.height} trackWidth={this.props.width} index={0} refreshVideoEditor={this.props.refreshVideoEditor}/>
                <ShadowArea trackHeight={this.props.height} trackWidth={this.props.width} index={1} refreshVideoEditor={this.props.refreshVideoEditor}/>
                <ControlPoint dispatch={this.props.dispatch} trackHeight={this.props.height} leftPosition={videoUtils.leftMarkerPosition} trackWidth={this.props.width} index={0} dragButtonSize={42} refreshVideoEditor={this.props.refreshVideoEditor}/>
                <ControlPoint dispatch={this.props.dispatch} trackHeight={this.props.height} leftPosition={videoUtils.rightMarkerPosition} trackWidth={this.props.width} index={1} dragButtonSize={42} refreshVideoEditor={this.props.refreshVideoEditor}/>
            </div>
        );
    }
});



/** WEBPACK FOOTER **
 ** ./src/components/videoEditor/VideoTrack.js
 **/